<div class="typo-small app-space-bottom">
  <span>
    <strong>{{entry.commCRU}}</strong>
    {{entry.commCRD | excDate: getRessource('DateTimeFormat')}}
  </span>
  <div *ngIf="entry.commType" class="typo-meta app-space-right">
    {{enmService.getEnumerationTextA('CommentType', entry.commType)}}
  </div>
</div>
<div (dblclick)="expand = !expand"
     class="app-textarea grid-1-auto-start app-space-right">
  <p [class.height-auto-fit]="expand"
     [class.height-auto]="!expand"
     [innerText]="entry.commText"
     class="md-textarea typo-small app-typo-overflow-hidden app-nospace">
  </p>
  <div [hidden]="isOverflow()" class="app-space-left app-space-right">
    <i (click)="expand = !expand"
       *ngIf="expand" [tooltip]="getRessource('Einklappen')"
       flow="left"
       class="search-filter-action far fa-angle-double-down"></i>
    <i (click)="expand = !expand"
       *ngIf="!expand" flow="left"
       [tooltip]="getRessource('Ausklappen')" class="search-filter-action far fa-angle-double-up"></i>
  </div>
</div>
